/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface SeatAssignmentResponse {
  id: string;
  org_id: string;
  user_id: string;
  status: string;
  assigned_at: string;
  deactivated_at: string | null;
}
